module.exports = __webpack_public_path__ + "img/chalkboard-teacher.7a2af391.svg";